import * as tslib_1 from "tslib";
import { EventEmitter, ElementRef } from "@angular/core";
import { BaseComponent } from "../../base/base.component";
import { AppComponent } from "../../app.component";
import { Router } from "@angular/router";
import { Location } from "@angular/common";
import { AlertUtils } from "../../../crossconcern/utilities/utils/alert.utils";
import { TableInfo } from "../../../crossconcern/models/tablelist/tableinfo.model";
import { TableInfoHeader } from "../../../crossconcern/models/tablelist/tableinfoheader.model";
import { ButtonsModel } from "../../../crossconcern/models/tablelist/button.model";
import { TABLELIST_BUTTON_COLOR_4, TABLELIST_BUTTON_ICON_CLASS_EDIT, TABLELIST_BUTTON_ICON_CLASS_VIEW } from "../../../crossconcern/utilities/properties/tablelist.property";
import { NurseryManager } from "../../../business/managers/nursery.manager";
import { finalize } from "rxjs/operators";
import { FormInfo } from "../../../crossconcern/models/form/forminfo";
import { FormInfoField } from "../../../crossconcern/models/form/forminfofield";
import { FORM_TYPE_TEXT, FORM_TYPE_TEXTAREA, FORM_WIDTH_COL_12, FORM_WIDTH_OFFSET_COL_0 } from "../../../crossconcern/utilities/properties/base.property";
import { Validators } from "@angular/forms";
var ShortcutListComponent = /** @class */ (function (_super) {
    tslib_1.__extends(ShortcutListComponent, _super);
    function ShortcutListComponent(appComponent, router, location, alertUtils, nurseryManager) {
        var _this = _super.call(this, appComponent, router, alertUtils, location) || this;
        _this.appComponent = appComponent;
        _this.router = router;
        _this.location = location;
        _this.alertUtils = alertUtils;
        _this.nurseryManager = nurseryManager;
        _this.sphereChosen = new EventEmitter();
        _this.closeSection = new EventEmitter();
        _this.shortcutAdded = new EventEmitter();
        _this.isAdding = false;
        return _this;
    }
    Object.defineProperty(ShortcutListComponent.prototype, "content", {
        set: function (content) {
            if (content) { // initially setter gets called with undefined
                this.formComponent = content;
            }
        },
        enumerable: true,
        configurable: true
    });
    ShortcutListComponent.prototype.ngOnInit = function () {
        var formInfoFields = [
            new FormInfoField(FORM_TYPE_TEXT, "SHORTCUT_LIST_COMPONENT_TITLE", "title", [
                Validators.required
            ], null, null, null, true, true, null, FORM_WIDTH_COL_12, FORM_WIDTH_OFFSET_COL_0),
            new FormInfoField(FORM_TYPE_TEXTAREA, "SHORTCUT_LIST_COMPONENT_DESC", "desc", [
                Validators.required
            ], null, null, null, true, true, null, FORM_WIDTH_COL_12, FORM_WIDTH_OFFSET_COL_0)
        ];
        this.formInfo = new FormInfo(formInfoFields, null);
    };
    ShortcutListComponent.prototype.ngOnChanges = function () {
        this.listUpdate();
    };
    ShortcutListComponent.prototype.setTable = function () {
        var _this = this;
        var headers = {
            "shortcut": new TableInfoHeader("SHORTCUT_LIST_COMPONENT_HEADER_NAME", false, this.sortAsc === true, this.sortField === "shortcut"),
            "actions": new TableInfoHeader("SHORTCUT_LIST_COMPONENT_HEADER_ACTIONS", false, false, false)
        };
        var items = [];
        for (var _i = 0, _a = this.shortcuts.shortcuts; _i < _a.length; _i++) {
            var shortcut = _a[_i];
            items.push({ "shortcut": shortcut.title ? shortcut.title : "" });
        }
        var buttons = [];
        buttons.push(new ButtonsModel("SHORTCUT_LIST_COMPONENT_TABLE_BUTTON_VIEW", TABLELIST_BUTTON_COLOR_4, TABLELIST_BUTTON_ICON_CLASS_VIEW, function (item) {
            _this.onViewSphereClick(item);
        }));
        if (this.editEnabled) {
            buttons.push(new ButtonsModel("SHORTCUT_LIST_COMPONENT_TABLE_BUTTON_EDIT", TABLELIST_BUTTON_COLOR_4, TABLELIST_BUTTON_ICON_CLASS_EDIT, function (item) {
                _this.editedShortcut = item;
                _this.onNewClick();
            }));
        }
        this.tableInfo = new TableInfo(headers, items, this.shortcuts.shortcuts.length, buttons);
    };
    ShortcutListComponent.prototype.onViewSphereClick = function (pos) {
        if (this.shortcuts.shortcuts[pos] && this.shortcuts.shortcuts[pos].photosphere) {
            this.sphereChosen.emit(this.shortcuts.shortcuts[pos].photosphere.uuid);
        }
    };
    ShortcutListComponent.prototype.onCloseClick = function () {
        this.closeSection.emit();
    };
    ShortcutListComponent.prototype.onNewClick = function () {
        var _this = this;
        if (this.isAdding) {
            if (this.editedShortcut !== undefined) {
                this.appComponent.startLoading();
                this.nurseryManager.deleteShortcut(this.shortcuts.shortcuts[this.editedShortcut].uuid)
                    .pipe(finalize(function () { return _this.appComponent.stopLoading(); }))
                    .subscribe(function () {
                    _this.listModified();
                });
            }
            else {
                this.isAdding = !this.isAdding;
            }
        }
        else if (this.editedShortcut !== undefined) {
            this.formInfo.fields[0].selectedValue = this.shortcuts.shortcuts[this.editedShortcut].title;
            this.formInfo.fields[1].selectedValue = this.shortcuts.shortcuts[this.editedShortcut].description;
            this.isAdding = !this.isAdding;
            setTimeout(function () { return _this.formComponent.updateFormValues(_this.formInfo); }, 1);
        }
        else {
            this.isAdding = !this.isAdding;
        }
    };
    /* eslint-disable camelcase, @typescript-eslint/camelcase */
    ShortcutListComponent.prototype.onSaveClick = function () {
        var _this = this;
        this.appComponent.startLoading();
        if (this.formComponent.form.value.title
            && this.formComponent.form.value.desc
            && (this.photosphereUUID || this.editedShortcut !== undefined)) {
            var shortcut = {
                title: this.formComponent.form.value.title,
                description: this.formComponent.form.value.desc,
                photosphere_uuid: this.editedShortcut !== undefined ? undefined : this.photosphereUUID
            };
            if (this.editedShortcut !== undefined) {
                this.nurseryManager.editShortcut(this.shortcuts.shortcuts[this.editedShortcut].uuid, shortcut)
                    .pipe(finalize(function () { return _this.appComponent.stopLoading(); }))
                    .subscribe(function () {
                    _this.listModified();
                });
            }
            else {
                this.nurseryManager.addShortcut(shortcut)
                    .pipe(finalize(function () { return _this.appComponent.stopLoading(); }))
                    .subscribe(function () {
                    _this.listModified();
                });
            }
        }
    };
    ShortcutListComponent.prototype.listModified = function () {
        var _this = this;
        this.editedShortcut = undefined;
        this.formInfo.fields[0].selectedValue = undefined;
        this.formInfo.fields[1].selectedValue = undefined;
        this.isAdding = !this.isAdding;
        setTimeout(function () { return _this.listUpdate(); }, 1);
    };
    ShortcutListComponent.prototype.listUpdate = function () {
        var _this = this;
        if (!this.isAdding) {
            this.appComponent.startLoading();
            this.nurseryManager.getShortcuts(10000, 0, this.nurseryUUID)
                .pipe(finalize(function () { return _this.appComponent.stopLoading(); }))
                .subscribe(function (list) {
                _this.shortcuts = list;
                _this.setTable();
            });
        }
    };
    return ShortcutListComponent;
}(BaseComponent));
export { ShortcutListComponent };
